import {PlusIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import React, {useState} from 'react';
import {Input} from '../../../components/Form/FormElements';

interface IProps {
  offset?: boolean;
  existingTags?: string[];
  onTagAdd: (tag: string) => void;
}

const AddTag: React.FC<IProps> = ({offset, onTagAdd, existingTags: list}) => {
  const [newTagValue, setNewTagValue] = useState('');
  const [addingTag, setAddingTag] = useState(false);

  const _onTagAdd = (tag: string) => {
    setAddingTag(true);
    onTagAdd(tag);
    setNewTagValue('');
    setAddingTag(false);
  };

  return (
    <div className={classNames('relative h-6', offset ? '-top-2' : '-top-2.5')}>
      <Input
        inputProps={{
          placeholder: 'add tag',
          value: newTagValue,
          onChange: (e) => setNewTagValue(e.target.value),
          onKeyDown: (e) => {
            if (
              !addingTag &&
              e.key === 'Enter' &&
              e.currentTarget.value.trim() !== ''
            ) {
              _onTagAdd(newTagValue);
            }
          },
          onBlur: (e) => {
            if (!addingTag && e.currentTarget.value.trim() !== '') {
              _onTagAdd(e.currentTarget.value);
              e.currentTarget.value = '';
            }
          },
          className:
            'border border-blue-600 rounded-md focus:ring-0 text-xs text-blue-600 placeholder-blue-600 w-full pr-8 h-6',
          list: 'tag-list',
        }}
      />
      <datalist id="tag-list">
        {list?.map((tag, index) => <option key={index} value={tag} />)}
      </datalist>
      <button
        className={classNames(
          'absolute right-0 h-6 w-6',
          offset ? 'top-2' : 'top-2.5',
        )}
        onClick={() => _onTagAdd(newTagValue)}
        disabled={newTagValue === '' || addingTag}>
        <PlusIcon className="text-blue-600 w-4 h-4" />
      </button>
    </div>
  );
};

export default AddTag;
